export default __webpack_public_path__ + "static/media/account.4bb538f0.svg";